import { GenericModel } from "../../../generic.model";
import { EmailModel } from "../../common/email.model";
import { TelephoneModel } from "../../dataList/station/telephone.model";
import { AddressModel } from "../../common/address/address.model";
import { makeModel } from "../../../../service/utils/utils.service";


export class CustomerModel extends GenericModel {
    public firstName: string;
    public lastName: string;
    public name: string;
    public addressArray: AddressModel[];
    public emailArray: EmailModel[];
    public telephoneArray: TelephoneModel[];

    protected fromJson(json?: any): boolean {
    this.firstName = json.firstName ?? null;
    this.lastName = json.lastName ?? null;
    this.name = json.name ?? null;
    this.addressArray = makeModel(json.addressArray, AddressModel);
    this.emailArray = makeModel(json.emailArray, EmailModel);
    this.telephoneArray = makeModel(json.telephoneArray, TelephoneModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.name !== null;
    }
}